import { Box, css, Fab, styled, useTheme } from '@mui/material';
import { IconArrowNarrowUp } from '@tabler/icons-react';
import { ScrollToTopProps } from './types';

export default function ScrollToTop({ isVisible, onClick }: ScrollToTopProps) {
  const { palette } = useTheme();

  return (
    <>
      <FabContainer isVisible={isVisible}>
        <Fab
          onClick={onClick}
          sx={{
            '&:hover': {
              bgcolor: palette.colors.purple[400],
            },
            bgcolor: palette.colors.purple[300],
          }}
        >
          <IconArrowNarrowUp color={palette.colors.white} size={30} />
        </Fab>
      </FabContainer>
    </>
  );
}

const FabContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isVisible',
})<{ isVisible: boolean }>`
  position: absolute;
  bottom: 56px;
  right: 56px;

  transition: opacity 200ms ease-in-out;
  visibility: hidden;
  opacity: 0;

  ${({ isVisible }) =>
    isVisible &&
    css`
      visibility: visible;
      opacity: 1;
    `}
`;
